import { Tag } from '@cian/components';
import * as React from 'react';

import { INotLastFloorTag } from '../../../state/tags/definitions/not_last_floor';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface INotLastFloorTagItemProps {
  tag: INotLastFloorTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const NotLastFloorTagItem = ({ onDeleteClick, tag, withNewTag }: INotLastFloorTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {(tag.value && 'Не') || 'Только'} последний этаж
    </TagComponent>
  );
};
